module.exports = __webpack_public_path__ + "img/service1.e2342c1c.png";